<details class="log-change-breakdown" (toggle)="onToggle($event)">
  <summary class="log-change-breakdown__heading">
    <span class="log-change-breakdown__title">
      @if (titleKey) {
        {{ titleKey | translate: titleParams }}
      } @else {
        {{ title }}
      }
      @if (actionKey) {
        ({{ actionKey | translate }})
      }
    </span>
    <span class="text-secondary">
      {{
        (changes.length === 1 ? 'oneChange' : 'numberOfChanges')
          | translate: { count: changes.length }
      }}
    </span>
    <mat-icon class="log-change-breakdown__expand-icon">expand_more</mat-icon>
  </summary>
  @if (isOpen) {
    <div class="log-change-breakdown__changes pl-1 ml-1">
      @for (change of changes; track $index) {
        <div class="log-change-breakdown__change">
          @if (change.oldValue !== undefined && !change.translationKey) {
            <span class="log-change-breakdown__field-name">
              {{ change.fieldName | translate: change.translationParams }}
              {{ 'valueChangedFrom' | translate }}
            </span>
            <span class="log-change-breakdown__old-value text-secondary">
              @if (change.oldValue !== null && change.oldValue !== '') {
                {{ change.oldValue }}
              } @else {
                {{ 'notDefined' | translate }}
              }
            </span>
            <span class="log-change-breakdown__field-name">
              {{ 'valueChangedTo' | translate }}
            </span>
            <span class="text-secondary">
              @if (change.value !== null && change.value !== '') {
                {{ change.value }}
              } @else {
                {{ 'notDefined' | translate }}
              }
            </span>
          } @else {
            <span class="log-change-breakdown__field-name">
              {{ change.fieldName | translate: change.translationParams }}
              @if (change.translationKey) {
                {{ change.translationKey | translate }}
              } @else {
                :
              }
            </span>
            @if (change.oldValue !== undefined) {
              <span class="log-change-breakdown__old-value text-secondary">
                {{ change.oldValue }}
              </span>
            } @else if (change.value !== null && change.value !== '') {
              <span class="text-secondary">
                <app-text-overflow-label [text]="change.value"></app-text-overflow-label>
              </span>
            } @else if (!change.translationKey) {
              <span class="text-secondary">{{ 'notDefined' | translate }}</span>
            }
          }
        </div>
      }
    </div>
  }
</details>
